import { SearchModelElementDataState } from '@/redux/modelElements/modelElements.types';
import { BioEntitiesPinsListItem } from './BioEntitiesPinsListItem';

interface BioEntitiesPinsListProps {
  bioEnititesPins: Array<SearchModelElementDataState>;
}

export const BioEntitiesPinsList = ({ bioEnititesPins }: BioEntitiesPinsListProps): JSX.Element => {
  return (
    <ul className="h-[calc(100%-224px)] max-h-[calc(100%-224px)] overflow-auto px-6 py-2">
      {bioEnititesPins &&
        bioEnititesPins.map(result => (
          <BioEntitiesPinsListItem
            key={result.modelElement.name}
            name={result.modelElement.name}
            pin={result.modelElement}
            entityNumberKey={result.modelElement.id}
          />
        ))}
    </ul>
  );
};
